function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.666992 6.16659C0.666992 3.22107 3.05481 0.833252 6.00033 0.833252C8.94584 0.833252 11.3337 3.22107 11.3337 6.16659C11.3337 8.67088 10.1179 9.6506 8.98448 10.5639C8.24117 11.1629 7.53329 11.7334 7.22699 12.6866L6.88699 13.7133C6.79166 13.9968 6.51909 14.1822 6.22032 14.1666H5.84699C5.54822 14.1822 5.27565 13.9968 5.18033 13.7133L4.84033 12.6866C4.52177 11.7362 3.80397 11.1663 3.05194 10.5692C1.89966 9.65437 0.666992 8.6757 0.666992 6.16659ZM4.00033 6.16658C4.00033 7.27115 4.89576 8.16659 6.00033 8.16659C6.53076 8.16659 7.03947 7.95587 7.41454 7.5808C7.78961 7.20573 8.00033 6.69702 8.00033 6.16658C8.00033 5.06202 7.1049 4.16658 6.00033 4.16658C4.89576 4.16658 4.00033 5.06202 4.00033 6.16658Z",
  fill: "#2F7067"
});

var SvgLocation = function SvgLocation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLocation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/location.5465e7ba.svg";
export { ForwardRef as ReactComponent };